import React, { FC } from 'react';
import { TypeCourseAccessItemFields, TypeImage } from '@/core/generated-types';
import { TypeMediaCollectionRecord } from '@/lib/api/playbackService/types';
import {
  Badge,
  HeaderText,
  InternalLinkWrapper,
  LuvImage,
  RichText,
} from '@/components';
import { HeaderSize } from '@/components/ui/HeaderText';
import { getCourseStatusDisplayText } from './utils';
import classNames from 'classnames';
import { TW_COURSE_ACCESS_ITEM_CLASSES } from '@/core/constants';
import { Document } from '@contentful/rich-text-types';

export interface TypeCourseAccessItemWithCourseData
  extends TypeCourseAccessItemFields {
  course: TypeMediaCollectionRecord | null;
  isHidden?: boolean;
}

const CourseAccessItem: FC<TypeCourseAccessItemWithCourseData> = ({
  details,
  statusDisplayCopy,
  badge,
  course,
  isHidden,
}) => {
  if (!course || isHidden) return null;

  const {
    cta: streamingPageLink,
    textHeading,
    textBody,
    image,
  } = details?.fields || {};

  const statusDisplayText = getCourseStatusDisplayText(
    course.status,
    statusDisplayCopy,
  );

  return (
    <InternalLinkWrapper
      link={streamingPageLink}
      classes={classNames(
        'container relative mx-auto h-full w-full rounded-b bg-white drop-shadow',
        TW_COURSE_ACCESS_ITEM_CLASSES.container,
      )}
    >
      <div className="absolute left-0 top-0 ml-6 mt-5 font-bold">
        {statusDisplayText && (
          <Badge {...{ ...badge.fields, text: statusDisplayText }} />
        )}
      </div>

      <LuvImage
        height={240}
        width={360}
        alt=""
        className={classNames(
          'w-full rounded-t',
          TW_COURSE_ACCESS_ITEM_CLASSES.image,
        )}
        imageData={image as TypeImage}
      />
      <div className="p-6 text-left">
        <HeaderText
          text={textHeading}
          size={HeaderSize.H3}
          align="left"
          classes="mb-3"
        />
        {textBody && <RichText content={textBody as Document} />}
      </div>
    </InternalLinkWrapper>
  );
};

export default CourseAccessItem;
